export const modelSpecificationTabInputs = [
    'model',
    'make',
    'fuelType',
    'category',
  ]